module.exports = __webpack_public_path__ + "static/media/email.a02ffeea.png";